import { Component, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';

import { TimerContent } from './timer-wrapper.model';
import { TimerComponent } from '../timer.component';

@Component({
  selector: 'wl-timer-wrapper',
  templateUrl: './timer-wrapper.component.html',
  standalone: true,
  imports: [TimerComponent],
})
export class TimerWrapperComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) set rendering(value: ComponentRendering) {
    this.content = new TimerContent(value);
  }

  content!: TimerContent;
}
